export enum Role {
	RBT = 'RBT_ROLE',
	BCBA = 'BCBA_ROLE',
	BCaBA = 'BCaBA_ROLE',
}
